<template>
  <section class="tab-body">
    <div class="row">
      <div class="col-md">
        <p class="tab-description">
          <span class="bold-font">Summary</span><br>
          Total guest count: {{ totalGuestCount }}
        </p>
      </div>

      <div class="col-md tab-description">
        <button @click="exportScansToPDF()" v-if="hasScans">
          Export QRCode Scan Logs List to PDF
        </button>
      </div>
    </div>
    <scans-list-view
      :scans="scans"
      :hasScans="hasScans"
      :convertEpochTime="convertEpochTime" />
  </section>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'

import ScansListView from '@/components/listview/ScansListView'

export default {
  components: {
    'scans-list-view': ScansListView,
  },
  data() {
    return {

    }
  },
  props: {
    passName: String,
    scans: Array,
    hasScans: Boolean,
    convertEpochTime: Function
  },
  computed: {
    totalGuestCount() {
      return this.scans.length
    }
  },
  mounted() {

  },
  methods: {
    exportScansToPDF() {
      const pdfName = this.passName
      const headRows = () => {
        return [{name: 'Name', check_in: 'Check-in Dates', check_out: 'Check-out Dates'}]
      }

      const bodyRows = this.scans.map(x => {
        const checkIns = x.check_in_dates.map(y => this.convertEpochTime(y)).join('\n')
        const checkOuts = x.check_out_dates.map(y => this.convertEpochTime(y)).join('\n')
        return {
          name: x.individual_name, check_in: checkIns, check_out: checkOuts
        }
      })

      const doc = new jsPDF('p', 'pt', 'a4')
      doc.text('Scan Logs for ' + pdfName, 40, 40)
      doc.autoTable({ head: headRows(), body: bodyRows, startY: 50 })
      doc.save('Scans-' + pdfName + '.pdf')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabview/LogsTab.vue